import React, { useEffect } from 'react';





import Icon1 from '../assets/img/about/icon1.png';
import Icon2 from '../assets/img/about/icon2.png';
import Icon3 from '../assets/img/about/icon3.png';
import Icon4 from '../assets/img/about/icon4.png';
import Icon11 from '../assets/img/about/icon11.png';
import Icon21 from '../assets/img/about/icon21.png';
import Icon31 from '../assets/img/about/icon31.png';
import Icon41 from '../assets/img/about/icon41.png';

import Start from '../assets/img/about/Star.png';

import Img1 from '../assets/img/cancellation/refund1.png';
import Img2 from '../assets/img/cancellation/refund2.png';
import Img3 from '../assets/img/cancellation/refund3.png';
import Img4 from '../assets/img/cancellation/refund4.png';
import Img5 from '../assets/img/cancellation/refund5.png';
import Img6 from '../assets/img/cancellation/refund6.png';
import Img7 from '../assets/img/cancellation/refund7.png';
import Img12 from '../assets/img/cancellation/cancel12.png';


import SeoHelmet from "../components/SeoHelmet";

const RefundPolicy = () => {

     useEffect(() => {
    document.body.classList.add('about-page');

    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <>
     <SeoHelmet />


        <section class="about cancellation">
            <div className='container'>
                <div className='mbrweb_row'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img1} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>Refund Policy</h2> 
                           <p>At thebhavanasingh.com, we invest significant time in planning batches, reserving slots, allocating trainers/resources, and preparing proprietary materials. Therefore:</p>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img2} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>1. No Refund Policy</h2>
                            <div className='warning'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img12} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                     <p><span className='warn_bold'>All purchases are final.</span></p>
                                  
                                </div>
                            </div> 
                           <p>We do not offer refunds for:</p> 
                           <ul>
                            <li>change of mind,</li>
                            <li>inability to attend,</li>
                            <li>partial attendance,</li>
                            <li>dissatisfaction with subjective outcomes,</li>
                            <li>personal scheduling conflicts,</li>
                            <li>accidental purchase.</li>
                        
                            </ul>                          
                        </div>
                    </div>
                </div>

                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img3} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>2. Exception Scenarios (Only if applicable)</h2> 
                           <p>If any of the below occurs, we may process a resolution as described:</p>
                           
                            <div className='mbr_inner'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img4} />
                                </div> 
                                <div className='mbr-col-sm-6'>
                                    <h2>A) Duplicate Payment / Wrongful Multiple Charges</h2>  
                                    <p>If you are charged more than once for the same transaction, you must email us <span>within 48 hours</span>of the charge with proof.</p>
                                    <p>7–10 business days</p>
                                    
                                </div>   
                            </div> 

                            <div className='mbr_inner'>
                                <div className='mbr-col-sm-6'>
                                    <img src={Img5} />
                                </div> 
                                <div className='mbr-col-sm-6'>
                                    <h2>B) Program Cancelled by Us (Rare)</h2> 
                                    <p>If we cancel a program and cannot offer a reasonable alternative date/batch:</p>
                                   <ul>
                            <li>you may choose either <span>(i) transfer/credit</span> or <span>(ii) refund</span>(only in this scenario),</li>
                            <li>refunds (if issued) are processed within <span>10 business days</span>after confirmation.</li>
                           
                            </ul> 
                                </div>   
                            </div> 

                           
                                                
                        </div>
                    </div>
                </div>
                
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img6} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>3. Chargebacks / Payment Disputes</h2>                           
                        </div>
                        <div className='warning'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img7} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                     <p>Raising a chargeback while continuing to access Services is treated as <span>misuse</span>. We may <span>suspend access</span> and share relevant transaction proof with the payment processor.</p>
                                  
                                </div>
                            </div>  
                    </div>
                   
                </div>

                <div className='mbr_bottom'>
                    <p>
                      For questions about this policy, please contact our support team.
                    </p>
                  
                </div>
            </div>
        </section>
       
    </>
  );
}; 

export default RefundPolicy;
